type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'InvoiceCommissionIndicator'
const nameSource = 'financial/invoiceCommissionIndicator'
const namePageTitle = 'Faturas'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Fatura',
  to: '/financial/invoiceCommissionIndicator',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/financial/invoiceCommissionIndicator/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/financial/invoiceCommissionIndicator/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/financial/invoiceCommissionIndicator/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
